function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.5 31.5C29.7091 31.5 31.5 29.7091 31.5 27.5L31.5 14.5H34.5H35.5V12.5H34.5H31.5V9.5V8.5H29.5V9.5V12.5H16.5C14.2909 12.5 12.5 14.2908 12.5 16.5V29.5H9.5H8.5V31.5H9.5H12.5V34.5V35.5H14.5V34.5V31.5L27.5 31.5ZM14.5 29.5L27.5 29.5C28.6046 29.5 29.5 28.6046 29.5 27.5L29.5 14.5H16.5C15.3955 14.5 14.5 15.3954 14.5 16.5V29.5Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 19,
  width: 6,
  height: 6,
  rx: 1,
  fill: "currentColor"
});

var SvgCropRotate = function SvgCropRotate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCropRotate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crop-rotate.d6bc259d.svg";
export { ForwardRef as ReactComponent };